export default {
  testPawId: "2696855680813154842", //评选官网id(第六届测试库)
  pawId: "2156234351813181445", //评选官网id(第五届)
  // newPawId: "2698153001441017861", //评选官网id(第六届)
  newPawId: "4626182649760088064", // 主会场、分会场id(第十届)
  pickActivityId: "4513368599221536738", //评选活动id(用于获取奖项类别)
}



// WEBPACK FOOTER //
// ./src/utils/global_val.js